// import React from 'react';
// import { Outlet } from 'react-router-dom';
// import FloatingChatButton from '../../components/Ami/FloatingChatButton';
// import ChatWindow from './Header/ChatWindow';
// import { useState } from 'react';
// // material-ui
// import { styled, useTheme } from '@mui/material/styles';
// import {
//   // useMediaQuery,
//   AppBar,
//   Box,
//   Toolbar
// } from '@mui/material';

// // project import
// import { drawerWidth } from 'config.js';
// import Header from './Header';
// import Sidebar from './Sidebar';

// // custom style
// const Main = styled((props) => <main {...props} />)(({ theme, open }) => ({
//   width: '100%',
//   minHeight: '100vh',
//   flexGrow: 1,
//   padding: theme.spacing(3),
//   transition: theme.transitions.create(['margin', 'width'], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen
//   }),
//   [theme.breakpoints.up('md')]: {
//     width: `calc(100% - ${drawerWidth}px)`,
//     marginLeft: `-${drawerWidth}px`,
//     ...(open && {
//       marginLeft: 0,
//       width: `calc(100% - ${drawerWidth}px)`,
//       transition: theme.transitions.create(['margin', 'width'], {
//         easing: theme.transitions.easing.easeOut,
//         duration: theme.transitions.duration.enteringScreen
//       })
//     })
//   }
// }));

// const OutletDiv = styled((props) => <div {...props} />)(({ theme }) => ({
//   [theme.breakpoints.down('md')]: {
//     padding: theme.spacing(3)
//   },
//   padding: theme.spacing(5)
// }));

// // ==============================|| MAIN LAYOUT ||============================== //

// const MainLayout = () => {
//   const theme = useTheme();
//   // const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
//   const [drawerOpen, setDrawerOpen] = React.useState(false);

//   const handleDrawerToggle = () => {
//     setDrawerOpen(!drawerOpen);
//   };
//   const [chatOpen, setChatOpen] = useState(false);


//   // React.useEffect(() => {
//   //   setDrawerOpen(matchUpMd);
//   // }, [matchUpMd]);

//   return (
//     <Box sx={{ display: 'flex', width: '100%' }}>
//       <AppBar className="bg-[#fff]" position="fixed" sx={{ zIndex: 1200 }}>
//         <Toolbar>
//           <Header drawerOpen={drawerOpen} drawerToggle={handleDrawerToggle} />
//         </Toolbar>
//       </AppBar>
//       <Sidebar drawerOpen={drawerOpen} drawerToggle={handleDrawerToggle} />
//       <Main
//         open={drawerOpen}
//         style={{
//           [theme.breakpoints.down('md')]: {
//             marginLeft: drawerOpen ? drawerWidth : 0,
//             width: `calc(100% - ${drawerOpen ? drawerWidth : 0}px)`,
//             transition: theme.transitions.create(['margin', 'width'], {
//               easing: theme.transitions.easing.easeOut,
//               duration: theme.transitions.duration.enteringScreen
//             })
//           }
//         }}
//       >
//         <Box sx={theme.mixins.toolbar} />
//         <OutletDiv>
//           <Outlet />
//         </OutletDiv>
//       </Main>
//       {/* {chatOpen && <ChatWindow onClose={() => setChatOpen(false)} />}

//       {!chatOpen && <FloatingChatButton onClick={() => setChatOpen(true)} />} */}
//     </Box>
//   );
// };  

// export default MainLayout;



import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, Toolbar } from '@mui/material';

import { drawerWidth } from 'config.js';
import Header from './Header';
import Sidebar from './Sidebar';

const Main = styled((props) => <main {...props} />)(({ theme, open }) => ({
  width: '100%',
  minHeight: '100vh',
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create(['margin', 'width', 'padding'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  [theme.breakpoints.up('md')]: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      marginLeft: 0,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['margin', 'width', 'padding'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      })
    })
  }
}));

const OutletDiv = styled((props) => <div {...props} />)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3)
  },
  padding: theme.spacing(5),
  height: '100%',
  boxSizing: 'border-box'
}));

const MainLayout = () => {
  const theme = useTheme();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  // const [chatOpen, setChatOpen] = useState(false);

  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);

  // camera route -> remove paddings to make iframe full-bleed under AppBar
  const isCameraRoute = location.pathname.startsWith('/main/stores/camera/');

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <AppBar className="bg-[#fff]" position="fixed" sx={{ zIndex: 1200 }}>
        <Toolbar>
          <Header drawerOpen={drawerOpen} drawerToggle={handleDrawerToggle} />
        </Toolbar>
      </AppBar>

      <Sidebar drawerOpen={drawerOpen} drawerToggle={handleDrawerToggle} />

      <Main
        open={drawerOpen}
        style={{
          [theme.breakpoints.down('md')]: {
            marginLeft: drawerOpen ? drawerWidth : 0,
            width: `calc(100% - ${drawerOpen ? drawerWidth : 0}px)`,
            transition: theme.transitions.create(['margin', 'width'], {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen
            })
          },
          padding: isCameraRoute ? 0 : undefined,
          backgroundColor: isCameraRoute ? '#000' : undefined
        }}
      >
        <Box sx={theme.mixins.toolbar} />
        <OutletDiv
          style={{
            padding: isCameraRoute ? 0 : undefined,
            height: isCameraRoute ? 'calc(100vh - 64px)' : undefined, // 64px default AppBar height
            backgroundColor: isCameraRoute ? '#000' : undefined
          }}
        >
          <Outlet />
        </OutletDiv>
      </Main>
    </Box>
  );
};

export default MainLayout;
